import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./screens/Home";
import ClientPortal from "./screens/ClientPortal";
import OpenTicket from "./screens/OpenTicket";
import AgendarEvento from "./screens/AgendarEvento";
import AdminLogin from "./screens/AdminLogin";

import AdminDashboard from "./screens/AdminDashboard";
import AdminTickets from "./screens/AdminTickets";
import AdminEvents from "./screens/AdminEvents";
import AdminAccessCodes from "./screens/AdminAccessCodes";
import AdminReports from "./screens/AdminReports";
import AdminRoute from "./routes/AdminRoute";

export default function App() {
  return (
    <BrowserRouter basename="/helpdesk">
      <Routes>

        {/* ROTAS PÚBLICAS */}
        <Route index element={<Home />} />
        <Route path="portal" element={<ClientPortal />} />
        <Route path="abrir-chamado" element={<OpenTicket />} />
        <Route path="agendar-evento" element={<AgendarEvento />} />

        {/* LOGIN ADMIN */}
        <Route path="admin" element={<AdminLogin />} />

        {/* ROTAS ADMIN PROTEGIDAS */}
        <Route path="admin" element={<AdminRoute />}>
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="tickets" element={<AdminTickets />} />
          <Route path="events" element={<AdminEvents />} />
          <Route path="codes" element={<AdminAccessCodes />} />
          <Route path="reports" element={<AdminReports />} />
        </Route>

      </Routes>
    </BrowserRouter>
  );
}
